import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import statisticService from '../../../services/statistics';
import moment from 'moment';

const initialState = {
  loading: false,
  salesData: null,
  error: '',
};

// Helper function to convert time parameter to date range
const convertTimeToDateRange = (time) => {
  const today = moment();
  let date_from, date_to;

  switch (time) {
    case 'subWeek':
      date_from = moment().subtract(7, 'days').format('YYYY-MM-DD');
      date_to = today.format('YYYY-MM-DD');
      break;
    case 'subMonth':
      date_from = moment().subtract(30, 'days').format('YYYY-MM-DD');
      date_to = today.format('YYYY-MM-DD');
      break;
    case 'subYear':
      date_from = moment().subtract(365, 'days').format('YYYY-MM-DD');
      date_to = today.format('YYYY-MM-DD');
      break;
    default:
      // Default to today if time parameter is not recognized
      date_from = today.format('YYYY-MM-DD');
      date_to = today.format('YYYY-MM-DD');
  }

  return { date_from, date_to };
};

export const fetchSales = createAsyncThunk(
  'statistics/fetchSales',
  (params = {}) => {
    const { time = 'subMonth', ...otherParams } = params;
    const dateRange = convertTimeToDateRange(time);
    const requestParams = {
      ...dateRange,
      ...otherParams,
    };
    return statisticService.getSales(requestParams).then((res) => res);
  }
);

const salesSlice = createSlice({
  name: 'sales',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchSales.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchSales.fulfilled, (state, action) => {
      const { payload } = action;
      state.loading = false;
      state.salesData = payload.data;
      state.error = '';
    });
    builder.addCase(fetchSales.rejected, (state, action) => {
      state.loading = false;
      state.salesData = null;
      state.error = action.error.message;
    });
  },
});

export default salesSlice.reducer;

